import { Component, Mixins, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import RichText from '@/_components/richText/richText/richText.vue'
import Tags from '@/views/Language/components/tags/tags.vue'
import AttachmentDropzone from '@/views/Attachment/components/dropzone/dropzone.vue'

import StringGroupModel from '@/views/Language/models/stringGroup'
import TagModel from '@/views/Language/models/tag'
import AttachmentModel from '@/views/Attachment/model/attachment'

@Component({
    name: 'string-group-input',
    components: { DialogTemplate, RichText, Tags, AttachmentDropzone },
})
export default class StringGroupInput extends Mixins<MixinInterface>() {
    bottomSheet = true
    @Prop({ required: true }) props!: any

    get stringGroup(): StringGroupModel | null {
        return this.props.stringGroup
    }

    get stringGroups(): Array<StringGroupModel> {
        return this.props.stringGroups
    }

    get tags(): Array<TagModel> {
        return this.$store.getters.tags
    }

    valid = true
    name = ''
    description: string | null = null
    editorId: null | string = null
    tagsAdded: Array<TagModel> = []
    attachmentsAdded: Array<any> = []

    handleTagCreated(tag: TagModel) {
        this.tagsAdded = [...this.tagsAdded, tag]
    }

    stringRules = [
        (v: any) =>
            (v && v.length > 1) ||
            this.getComplexTranslations(
                'language_fe.stringGroup.dialog_input.validation.name.must_be_min_length'
            ),
        (v: any) =>
            /^[A-Za-z0-9-_.]+$/.test(v) ||
            this.getComplexTranslations(
                'language_fe.stringGroup.dialog_input.validation.name.must_follow_pattern'
            ),
        (v: any) =>
            this.testStringGroupName(v) ||
            this.getComplexTranslations(
                'language_fe.stringGroup.dialog_input.validation.name.must_be_unique'
            ),
    ]

    testStringGroupName(input: string) {
        let res = true
        if (input.length > 1) {
            this.stringGroups.map((obj: StringGroupModel) => {
                if (
                    this.stringGroup &&
                    this.stringGroup.name.toString().toLowerCase() == input.toString().toLowerCase()
                ) {
                    res = true
                } else if (obj.name.toString().toLowerCase() == input.toString().toLowerCase()) {
                    res = false
                }
            })
        }

        return res
    }

    handleAttachmentCreated(attachments: Array<AttachmentModel>) {
        this.attachmentsAdded = attachments
    }

    loadingAttachments = false
    onGetAttachments(attachments: Array<any>) {
        if (this.stringGroup) {
            this.postAttachment(attachments, this.stringGroup)
        } else {
            this.attachmentsAdded = [...this.attachmentsAdded, ...attachments]
        }
    }

    async postAttachment(attachments: Array<any>, stringGroup: StringGroupModel) {
        this.loadingAttachments = true
        if (stringGroup) {
            await Promise.all(
                attachments.map(async (file) => {
                    await stringGroup.postAttachment(file.id)
                })
            )
            await stringGroup.get()
        }
        this.loadingAttachments = false
    }

    async showAttachment(attachment: AttachmentModel) {
        if (this.stringGroup) {
            let res: any = await attachment.showLog(attachment, {})

            if (res && res.delete) {
                let index = this.stringGroup.attachments.findIndex(
                    (item) => item._id == attachment._id
                )
                this.stringGroup.attachments.splice(index, 1)

                await this.stringGroup.get()
            }
        }
    }

    deleteAttachment(index) {
        this.attachmentsAdded.splice(index, 1)
    }

    init() {
        if (this.stringGroup) {
            this.name = this.stringGroup.name
            this.description = this.stringGroup.description
            this.tagsAdded = this.stringGroup.tags
        }

        this.editorId = crypto['randomUUID']()
    }

    loading = false

    async patchStringGroup() {
        if (this.valid && this.stringGroup) {
            this.loading = true

            let data = {
                type: this.stringGroup._type,
                id: this.stringGroup._id,
                attributes: {
                    name: this.name,
                    description: this.description ? JSON.stringify(this.description) : null,
                },
                ...(this.tagsAdded.length > 0 && {
                    relationships: {
                        tags: {
                            data: this.tagsAdded.map((tag) => {
                                return { id: tag._id, type: tag._type }
                            }),
                        },
                    },
                }),
            }

            let stringGroup = await this.stringGroup.patch(data)

            this.loading = false
            this.$emit('close', stringGroup)
        }
    }

    async postStringGroup() {
        if (this.valid) {
            this.loading = true

            let data = {
                type: 'stringGroup',
                attributes: {
                    name: this.name,
                    description: this.description ? JSON.stringify(this.description) : null,
                },
                ...(this.tagsAdded.length > 0 && {
                    relationships: {
                        tags: {
                            data: this.tagsAdded.map((tag) => {
                                return { id: tag._id, type: tag._type }
                            }),
                        },
                    },
                }),
            }

            let stringGroup = await StringGroupModel.post(data).catch(() => {
                //
            })
            await this.postAttachment(this.attachmentsAdded, stringGroup)

            this.loading = false
            this.editorId = crypto['randomUUID']()

            this.$emit('close', stringGroup)
        }
    }

    async submit() {
        if (this.valid) {
            if (this.stringGroup) {
                await this.patchStringGroup()
            } else {
                await this.postStringGroup()
            }
        }
        this.$emit('close', true)
    }

    async mounted() {
        if (this.stringGroup) {
            await this.stringGroup.get()
        }
        this.init()
    }
}
